import React, { useEffect, useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Card,
  CardContent,
  Radio,
  TextField,
  FormControlLabel,
  FormControl,
} from "@mui/material";
import { getProjectResponse } from "../../services/transaction.service";
import { useLocation } from "react-router-dom";
import Styles from "./ClientFeedbackForm.module.scss";

const SubmittedForm = () => {
  const location = useLocation();
  const dataReceived = location.state;
  const [data, setData] = useState({});

  const GetTemplateData = async () => {
    try {
      const tokenID = dataReceived?.responseId;
      const res = await getProjectResponse(tokenID);
      const modifiedData = res?.data || {};
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetTemplateData();
  }, []);

  return (
    <div className="mainContent">
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }} />

      <Box sx={{ height: "100%" }}>
        <Stack sx={{ mb: 2 }}>Total Score : {data?.totalScore}</Stack>

        <Stack
          sx={{
            height: "75vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ overflowY: "auto", flexGrow: 1 }}>
            {data?.questions?.map((question) => {
              // ✅ Find the chosen option object
              const chosenOption = question.options.find(
                (opt) => opt.optionsName === question.answer
              );

              return (
                <Card
                  className={Styles.QuestionCard}
                  key={question._id}
                  sx={{ background: "#e4e1e1", mb: 2 }}
                >
                  <CardContent>
                    {/* Question Title */}
                    <Typography className={Styles.Questions}>
                      {question.questionName} - Score ({question.score})
                    </Typography>

                    {/* Options */}
                    <FormControl component="fieldset" className={Styles.Options}>
                      {question.options.map((option) => (
                        <FormControlLabel
                          key={option._id}
                          value={option.optionsName}
                          control={
                            <Radio
                              sx={{
                                color: "#00675D",
                                "&.Mui-checked": {
                                  color: "#00675D",
                                },
                              }}
                              checked={question.answer === option.optionsName}
                            />
                          }
                          label={option.optionsName}
                        />
                      ))}
                    </FormControl>

                    {/* ✅ Remark Field */}
                    {question.remark && (
                      <Box mt={3}>
                        <Typography sx={{ color: "text.primary", mb: 1 }}>
                          You selected{" "}
                          <strong>{chosenOption?.optionsName}</strong> for{" "}
                          <strong>{question.questionName}</strong> – Why did you
                          answer this?
                        </Typography>
                        <TextField
                          multiline
                          rows={3}
                          fullWidth
                          variant="outlined"
                          value={question.remark}
                          InputProps={{
                            readOnly: true, // disable editing
                          }}
                          sx={{
                            borderColor: "#C3C3C3",
                            "& .MuiOutlinedInput-root": {
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#C3C3C3",
                              },
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C3C3C3",
                            },
                            "& .MuiOutlinedInput-input": {
                              padding: "12px",
                            },
                          }}
                        />
                      </Box>
                    )}
                  </CardContent>
                </Card>
              );
            })}

            {/* ✅ Additional Feedback */}
            {data?.additionalFeedback && (
              <Box mt={5}>
                <Card className={Styles.QuestionCard}>
                  <CardContent>
                    <Typography sx={{ color: "text.primary", mb: 1 }}>
                      {data?.reminderText}
                    </Typography>
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      value={data?.additionalFeedback}
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{
                        borderColor: "#C3C3C3",
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C3C3C3",
                          },
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#C3C3C3",
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "16px",
                        },
                      }}
                    />
                  </CardContent>
                </Card>
              </Box>
            )}
          </Box>
        </Stack>
      </Box>
    </div>
  );
};

export default SubmittedForm;
